import { chapterPlaceholder } from 'assets';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';

import { ShouldRender } from '../../../shared/basic/ShouldRender';

interface Chapter {
  slug: string;
  schoolId: number | string;
  postId: number | string;
  reading_history?: boolean;
  postImage?: string;
  reading_time?: string;
  title: string;
}

interface SchoolData {
  slug: string;
}

interface ChapterCardProps {
  chapter: Chapter;
  index: number;
  schoolData: SchoolData;
}

const ChapterCard: FC<ChapterCardProps> = ({ chapter, index, schoolData }) => {
  return (
    <Link
      href={`/schools/${schoolData?.slug}/${chapter?.slug}/?school_id=${chapter?.schoolId}&post_id=${chapter?.postId}`}
      key={index}
    >
      <div className='flex items-center justify-center mb-3 gap-x-3'>
        <div className='text-lg lg:text-[32px] font-light text-white'>
          {String(index + 1).padStart(2, '0')}
        </div>
        <div
          className={clsx(
            !chapter?.reading_history ? 'bg-[#282829]' : 'bg-primary',
            'h-[2px] md:h-1 rounded-full w-full',
          )}
        ></div>
      </div>

      <div className='w-full h-24 md:h-[200px] min-w-[160px] md:min-w-[300px] rounded-sm md:rounded-xl mb-4 relative overflow-hidden'>
        <Image
          alt={chapter?.title || 'Chapter Image'}
          src={
            chapter?.postImage ? `${chapter?.postImage}` : chapterPlaceholder
          }
          fill
        />
      </div>

      <ShouldRender check={chapter?.reading_time}>
        <div className='mb-2'>
          <span className='text-[#ff6b35] text-sm font-medium'>
            {`${Math.round((Number(chapter?.reading_time) || 0) / 60)} Minutes`}
          </span>
        </div>
      </ShouldRender>

      <h3 className='text-white text-sm md:text-lg font-medium leading-relaxed'>
        {chapter.title}
      </h3>
    </Link>
  );
};

export default ChapterCard;
